const Conference = () => {
  return (
    <div>
      <h1>Conference</h1>
    </div>
  );
};

export default Conference;
